module.exports = __webpack_public_path__ + "img/qitiFire.e4b64369.png";